import type { QueryPayload } from "../types";

type QueryParamValue = QueryPayload[keyof QueryPayload] | string;

export function serializeQueryParamValue(value: QueryParamValue): string {
	return typeof value === "string" ? value : JSON.stringify(value);
}

export function appendSerializedQueryParams(searchParams: URLSearchParams, query: QueryPayload): void {
	Object.entries(query).forEach(([key, value]) => {
		if (value !== undefined) {
			searchParams.set(key, serializeQueryParamValue(value));
		}
	});
}

export function buildJsonQueryStringParam(paramName: string, value: unknown): string {
	if (value == null) {
		return "";
	}
	return `?${paramName}=${encodeURIComponent(JSON.stringify(value))}`;
}
